import React, { useState, useEffect } from "react";
import { FaInstagram, FaTelegramPlane, FaBars, FaTimes, FaWhatsapp } from "react-icons/fa";
import { Link, animateScroll as scroll } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";
import ContactForm from "../contact-form/contact-form";
import "./header.scss";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => setMenuOpen(false);
  const scrollToTop = () => scroll.scrollToTop();
  const openForm = () => {
    setIsFormOpen(true);
    setMenuOpen(false);
  };
  const closeForm = () => setIsFormOpen(false);

  return (
    <motion.header
      className={`header ${scrolled ? "scrolled" : ""}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* Logo */}
      <motion.div
        className="logo"
        onClick={scrollToTop}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Na_Sokah_Uz
      </motion.div>

      {/* Navigation */}
      <nav className={`nav ${menuOpen ? "active" : ""}`}>
        <ul>
          <li>
            <Link
              to="advantages"
              spy={true}
              smooth={true}
              offset={-80}
              duration={800}
              onClick={handleLinkClick}
              className="nav-link"
            >
              Преимущества
            </Link>
          </li>
          <li>
            <Link
              to="programs"
              spy={true}
              smooth={true}
              offset={-80}
              duration={800}
              onClick={handleLinkClick}
              className="nav-link"
            >
              Программы
            </Link>
          </li>
          <li>
            <Link
              to="about"
              spy={true}
              smooth={true}
              offset={-80}
              duration={800}
              onClick={handleLinkClick}
              className="nav-link"
            >
              О нас
            </Link>
          </li>
          <li>
            <Link
              to="contacts"
              spy={true}
              smooth={true}
              offset={-80}
              duration={800}
              onClick={handleLinkClick}
              className="nav-link"
            >
              Контакты
            </Link>
          </li>
        </ul>
      </nav>

      {/* Socials + Burger */}
      <div className="actions">
        <motion.a
          href="https://www.instagram.com/na_sokah_uz?igsh=NWE1aG4wMHl4MW1l"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1, y: -2 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaInstagram />
        </motion.a>
        <motion.a
          href="https://t.me/nasokahuz"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1, y: -2 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaTelegramPlane />
        </motion.a>
        <motion.a
          href="https://wa.me/998500120230"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1, y: -2 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaWhatsapp />
        </motion.a>

        <motion.button
          className="order-btn"
          onClick={openForm}
          whileHover={{ scale: 1.05, y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          Заказать
        </motion.button>

        {/* Burger Menu */}
        <motion.div
          className="burger"
          onClick={() => setMenuOpen(!menuOpen)}
          whileTap={{ scale: 0.9 }}
        >
          <AnimatePresence mode="wait">
            {menuOpen ? (
              <motion.div
                key="close"
                initial={{ rotate: -90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: 90, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                <FaTimes />
              </motion.div>
            ) : (
              <motion.div
                key="menu"
                initial={{ rotate: 90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: -90, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                <FaBars />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Contact Form Modal */}
      <ContactForm isOpen={isFormOpen} onClose={closeForm} />
    </motion.header>
  );
};

export default Header;
